/*
  Links can be used instead of MinimalButtons for links within blocks of text.

  By default, links do not change the color of enclosed elements (e.g. text),
  unless you specify a variant.
*/

import cx from 'classnames'
import type { MouseEventHandler, ReactNode } from 'react'
import { Link } from 'react-router-dom'

import cs from './link.scss'

export interface LinkProps {
  className?: string
  children?: ReactNode
  to: string
  external?: boolean
  variant?: 'error' | 'primary'
  onClick?: MouseEventHandler<HTMLAnchorElement>
}

const MyLink = ({ className, children, to, external, variant, onClick }: LinkProps) => {
  if (external) {
    return (
      <a
        href={to}
        className={cx(className, cs.link, variant && cs[variant])}
        target='_blank'
        rel='noopener noreferrer'
        onClick={onClick}
      >
        {children}
      </a>
    )
  }
  return (
    <Link
      className={cx(className, cs.link, variant && cs[variant])}
      to={to}
      onClick={onClick}
    >
      {children}
    </Link>
  )
}

export default MyLink
